import {DumpsterFire} from "../../DumpsterFire";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {IBigWinLevel} from "../../server/DumpsterFireData";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {TimelineLite} from "gsap";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";
import {DFSymbolUtils} from "../../utils/DFSymbolUtils";
import {DumpsterFireSymbol} from "../../reels/DumpsterFireSymbol";
import {ISymbol} from "../../../core/reel/simplereel/IReelData";
import {DumpsterFireModel} from "../../server/DumpsterFireModel";


export class DFBigWinRunner implements SimplePresentation {
    public static _bigWinSound: string = "";

    shouldRun(): boolean {
        return (DumpsterFire.model.winRatio >= DumpsterFireModel.bigWinThresholdReached() && DumpsterFire.model.data.nextMode !== DumpsterFireGameMode.NORMAL_AVALANCHE && DumpsterFire.model.data.nextMode !== DumpsterFireGameMode.FREESPIN_AVALANCHE) && !DumpsterFire.model.gameData.brokeTheBank && !(DumpsterFire.isWinBelowStake() && DumpsterFire.model.data.nextMode.indexOf("NORMAL") > -1 && ((DumpsterFire.model.data.mode.indexOf("NORMAL") > -1)));
    }

    start(controller: SimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = DumpsterFire.model.getBigWinLevels(DumpsterFire.model.winRatio),
            maxLevel: number = levels.length,
            tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    if (DFBigWinRunner._bigWinSound) {
                        DumpsterFire.soundPlayer.stopSound(DFBigWinRunner._bigWinSound);
                    }
                    DumpsterFire.soundPlayer.getRestoreSound(DumpsterFire.bgMulti.largestMulti());
                    DumpsterFire.bigWinView.resetBigWinAnim();
                    controller.finish();
                }
            })
        const totalWin: number = DumpsterFire.model.gameData.spinWin;
        DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
        DumpsterFire.bigWinView.maxLevel = maxLevel;
        let levelAborted: boolean;
        tl.add([DumpsterFire.allReelsView.getShakeAnimation(1, 1, 500, 6, 0.3),
            () => {
                DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_START);
            }], 0);
        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = (index === 0) ? 0 : bigWinLevel.from * DumpsterFire.model.gameData.playedBetValue,
                to: number = ((index + 1) === maxLevel) ? totalWin : bigWinLevel.to * DumpsterFire.model.gameData.playedBetValue;
            tl.add(() => {
                levelAborted = false;
                if (index === 0) {
                    DumpsterFire.soundPlayer.fadeMusic({
                        name: "",
                        duration: 100,
                        to: 0
                    });
                }
                DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.gameData.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
                DFBigWinRunner._bigWinSound = DumpsterFireSound.BIG_WIN_LEVEL + (index + 1);
                controller.setSkipCallback(() => {
                    levelAborted = true;
                    if (index === 0) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_1_ENDS);
                    } else if (index === 1) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_2_ENDS);
                    } else if (index === 2) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_3_ENDS);
                    } else if (index === 3) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_4_ENDS);
                    } else if (index === 4) {
                        DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_5_ENDS);
                    }
                    tl.seek(index + "myLabel", false);
                    if (levelAborted || DFBigWinRunner._bigWinSound) {
                        DumpsterFire.soundPlayer.stopSound(DFBigWinRunner._bigWinSound);
                    }
                });
            });

            tl.add([DumpsterFire.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id, index),
                () => {
                    DumpsterFire.soundPlayer.playSound(DFBigWinRunner._bigWinSound);
                }]);
            tl.addLabel(index + "myLabel", "<3.0");
            tl.add(() => {
                controller.setSkipCallback(() => {
                    if (index + 1 !== maxLevel) {
                        if (index + 1 === 1) {
                            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_2_ENDS);
                        } else if (index + 1 === 2) {
                            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_3_ENDS);
                        } else if (index + 1 === 3) {
                            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_4_ENDS);
                        } else if (index + 1 === 4) {
                            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.BIG_WIN_5_ENDS);
                        }
                        levelAborted = true;
                        tl.seek((index + 1) + "myLabel", false);
                        if (levelAborted || DFBigWinRunner._bigWinSound) {
                            DumpsterFire.soundPlayer.stopSound(DFBigWinRunner._bigWinSound);
                        }
                    }
                });
            }, index + "myLabel");
        }
        tl.add(() => {
            if (levelAborted && DFBigWinRunner._bigWinSound) {
                DumpsterFire.soundPlayer.stopSound(DFBigWinRunner._bigWinSound);
            }
            DFBigWinRunner._bigWinSound = "";
            if (!DumpsterFire.model.data.brokeTheBank) {
                DumpsterFire.soundPlayer.fadeMusic({
                    name: "",
                    duration: 1000,
                    to: 1
                });
            }
            controller.setSkipCallback();
        });
        tl.to(this, {
            duration: 0.2
        });
        tl.add(DumpsterFire.bigWinView.hide(0.5));
    }
}